import pxToRem from "../../../Themes/Functions/pxToRem";

export const rootBox = {
  display: "flex",
  width: "100vw",
  height: "100vh",
  backgroundColor: "white.main",
  // alignItems: "center",
  // justifyContent: "center",
};

export const formPanel = {
  display: "flex",
  width: "50%",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  bgcolor: "#064d51",
  borderTopRightRadius: pxToRem(40),
  borderBottomRightRadius: pxToRem(40),
};

export const rightPanel = {
  display: "flex",
  width: "50%",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
};

export const formCard = {
  width: "50%",
  p: 4,
};

export const header = {
  mb: 2,
  justifyContent: "center",
  alignItems: "center",
};
